import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import { SETTINGS_MODULE } from '../../configs/moduleNames';
import { BEGIN, FAILED, SUCCESSFUL } from '../../configs/actionNames';

export const CREATE_SETTINGS = '_CREATE_SETTINGS';
export const DELETE_SETTINGS = '_DELETE_SETTINGS';
export const EDIT_SETTINGS = '_EDIT_SETTINGS';
export const LOAD_SETTING_BY_ID = '_LOAD_SETTING_BY_ID';
export const LOAD_SETTINGS = '_LOAD_SETTINGS';

export const createSettings = createDeferredAction(SETTINGS_MODULE + CREATE_SETTINGS);
export const createSettingsSuccessful = createAction(SETTINGS_MODULE + CREATE_SETTINGS + SUCCESSFUL);
export const createSettingsFailed = createAction(SETTINGS_MODULE + CREATE_SETTINGS + FAILED);

export const deleteSettings = createDeferredAction(SETTINGS_MODULE + DELETE_SETTINGS);
export const deleteSettingsSuccessful = createAction(SETTINGS_MODULE + DELETE_SETTINGS + SUCCESSFUL);
export const deleteSettingsFailed = createAction(SETTINGS_MODULE + DELETE_SETTINGS + FAILED);

export const editSettings = createDeferredAction(SETTINGS_MODULE + EDIT_SETTINGS);
export const editSettingsSuccessful = createAction(SETTINGS_MODULE + EDIT_SETTINGS + SUCCESSFUL);
export const editSettingsFailed = createAction(SETTINGS_MODULE + EDIT_SETTINGS + FAILED);

export const loadSettingById = createDeferredAction(SETTINGS_MODULE + LOAD_SETTING_BY_ID);
export const loadSettingByIdSuccessful = createAction(SETTINGS_MODULE + LOAD_SETTING_BY_ID + SUCCESSFUL);
export const loadSettingByIdFailed = createAction(SETTINGS_MODULE + LOAD_SETTING_BY_ID + FAILED);

export const loadSettings = createDeferredAction(SETTINGS_MODULE + LOAD_SETTINGS);
export const loadSettingsBegin = createAction(SETTINGS_MODULE + LOAD_SETTINGS + BEGIN);
export const loadSettingsSuccessful = createAction(SETTINGS_MODULE + LOAD_SETTINGS + SUCCESSFUL);
export const loadSettingsFailed = createAction(SETTINGS_MODULE + LOAD_SETTINGS + FAILED);
